module.exports = __webpack_public_path__ + "img/authorityLogo5.8efd93a7.png";